module.exports = __webpack_public_path__ + "img/35.49a652cd.png";